import { saveAs } from "file-saver";
import { useState, useEffect } from "react";
import { MdDelete, MdDownload, MdEdit, MdLibraryAdd, MdSearch } from "react-icons/md";
import { utils, write } from "xlsx";
import { createGroupDoc, deleteGroupDoc, getEventsDoc, getExhibitorsDoc, getGroupsDoc, updateGroupDoc } from "../../Requests/firebaseFirestore";
import AreYouSure from "../AreYouSure";
import Modal from "../Modal";

export default function AllGroups() {
  const [showGroupModal, setShowGroupModal] = useState(false)
  const [groups, setGroups] = useState([])
  const [groupList, setgroupList] = useState([])
  const [events, setEvents] = useState([])
  const [exhibitors, setExhibitors] = useState([])
  const [exhibitorList, setExhibitorList] = useState([])
  const [search, setSearch] = useState('')
  const [editing, setEditing] = useState('')
  const [sureModal, setSureModal] = useState(false)
  const [groupToDelete, setGroupToDelete] = useState()
  const initialGroupValue = {
    name:'',
    event:'',
    exhibitor:'',
  }
  const [newGroup, setNewGroup] = useState(initialGroupValue)

  const reloadGroupList = async (groups) => {
    if(groups){
      setgroupList(groups)
    }else{
      const res = await getGroupsDoc()
      setGroups(res)
      setgroupList(res)
    }

  }

  useEffect(()=>{
    reloadGroupList()
  },[])

  
  const handleInputChange = (e) => {
    const {name, value} = e.target
    setNewGroup({...newGroup,[name]: value})
  }

  const handleSubmit = async (e)=>{
    e.preventDefault()
    const eventId = newGroup.event
    const exhibitorId = newGroup.exhibitor
    let groupEvent
    let groupExhibitor
    events.forEach((event)=>{
      if(event.id===eventId){
        groupEvent = event
      }
    })
    exhibitors.forEach((exhibitor)=>{
      if(exhibitor.id === exhibitorId){
        groupExhibitor = exhibitor
      }
    })
    if(editing===''){
      await createGroupDoc({...newGroup, event:{name:groupEvent.name, id:groupEvent.id}, exhibitor: {fullName:groupExhibitor.fullName, id:groupExhibitor.id}})
    }else{
      await updateGroupDoc({...newGroup, event:{name:groupEvent.name, id:groupEvent.id}, exhibitor: {fullName:groupExhibitor.fullName, id:groupExhibitor.id}})
    }
    reloadGroupList()
    handleModal()
  }
  
  const handleSureModal = async (res, group) => {
    if(group){
      setGroupToDelete(group)
    }
    if(res === 'accepted'){
      await deleteGroupDoc(groupToDelete.id)
      setGroupToDelete('')
      reloadGroupList()
    }
    setSureModal(!sureModal)
  }

  const updateExhibitorList = async(event) => {
    let res = []
    let filteredList = []
    if(exhibitors.length === 0){
      res = await getExhibitorsDoc()
      setExhibitors(res)
      res.forEach((exhibitor)=>{
        exhibitor.events.forEach((e)=>{
          if(e.id===event){
            filteredList = [...filteredList, exhibitor]
          }
        })
      })
    }else{
      exhibitors.forEach((exhibitor)=>{
        exhibitor.events.forEach((e)=>{
          if(e.id===event){
            filteredList = [...filteredList, exhibitor]
          }
        })
      })
    }
    setExhibitorList(filteredList)
  }
  
  const handleModal = async (group) => {
    if(group){
      const {id} = group
      updateExhibitorList(group.event.id)
      setEditing(id)
      setNewGroup({...group, event: group.event.id, exhibitor:group.exhibitor.id})
    }else{
      setEditing('')
      setNewGroup(initialGroupValue)
    }
    await setEventsList()
    setShowGroupModal(!showGroupModal)
  }

  const setEventsList = async () => {
    if(events.length===0){
      const res = await getEventsDoc();
      setEvents(res)
    }
  }

  const handleSearch = (e) => {
    e.preventDefault()
    let filteredList = []
    groups.forEach((group)=>{
      if(group.name.includes(search)){
        filteredList = [...filteredList, group]
      } 
    })
    reloadGroupList(filteredList)
  }

  const handleDownload = () => {
    let toXls = []
    groupList.forEach((group)=>{
      toXls = [...toXls, {'Evento':group.event.name, 'Expositor':group.exhibitor.company, 'Name':group.name}]
    })

    const ws = utils.json_to_sheet(toXls)
    const wb = {
      Sheets:{
        'data':ws
      },
      SheetNames:['data']
    }
    const eb = write(wb,{bookType:'xlsx',type:'array'})
    const data = new Blob([eb],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UFT-8'})
    saveAs(data, 'ChannelTalks-grupos.xlsx')
  }

  return(<>
  <div className="table-holder">
    <table className="table-auto min-w-[600px]">
      <thead>
        <tr>
          <th colSpan='100%'>
            <div className="px-5 flex w-full items-center justify-between">
              <div className="flex gap-2">
                <button className="light-button" onClick={()=>{handleModal()}}><MdLibraryAdd size={25}/></button>
                <form onSubmit={handleSearch} className='flex flex-row gap-2'>
                  <input type="text" className=" font-normal text-black" placeholder="Buscar por nombre" value={search} onChange={(e)=>{setSearch(e.target.value)}}/>
                  <button className="light-button"><MdSearch size={25}/></button>

                </form>
              </div>
              <button className="light-button flex gap-1" onClick={handleDownload}>
                <MdDownload size={25}/> Descargar
              </button>
            </div>
          </th>
        </tr>
        <tr>
          <th>Acciones</th>
          <th>Nombre</th>
          <th>Expositor</th>
          <th>Evento</th>
        </tr>
      </thead>
      <tbody>
        {groupList.length>0?
          <>
            {groupList.map((group, index)=>{return(<tr key={index}>
              <td className="flex justify-center gap-2">
                <button className="action-button border-amber-500 text-amber-500 hover:text-white hover:bg-amber-500 active:bg-amber-700 duration-150" onClick={()=>{handleModal(group)}}><MdEdit size={25}/></button>
                <button className="action-button border-red-500 text-red-500 hover:text-white hover:bg-red-500 active:bg-red-700 duration-150" onClick={()=>{handleSureModal('', group)}}><MdDelete size={25}/></button>
              </td>
              <td>{group.name}</td>
              <td>{group.exhibitor.fullName}</td>
              <td>{group.event.name}</td>
            </tr>)})}
          </>
        :
        <tr><td colSpan='100%'>No se encontraron grupos</td></tr>
        }
      </tbody>
    </table>

  </div>
    <Modal isActive={showGroupModal} handle={handleModal} title={editing===''?'Crear grupo':'Editar grupo'}>
      <form className='flex flex-col gap-4' onSubmit={handleSubmit}>
        <div className="input-holder w-[75%]">
          <input type='text' name="name" id="new-group-name" onChange={handleInputChange} value={newGroup.name} required></input>
          <label htmlFor="new-group-name">Nombre</label>
        </div>
        <div className="input-holder w-[75%]">
          <select id="new-group-event" onChange={(e)=>{handleInputChange(e); updateExhibitorList(e.target.value)}} name='event' value={newGroup.event} required >
          <option value="" disabled hidden></option>
            {events.map((event, index)=>{return(<option key={index} value={event.id} >{event.name}</option>)})}
          </select>
          <label htmlFor="new-group-event">Evento</label>
        </div>
        <div className="input-holder w-[75%]">
          <select name="exhibitor" id="new-group-exhibitor" onChange={handleInputChange} value={newGroup.exhibitor} required disabled={newGroup.event===''}>
            <option value="" disabled hidden></option>
            {exhibitorList.map((exhibitor, index) => {return(<option key={index} value={exhibitor.id}>{exhibitor.fullName}</option>)})}
          </select>
          <label htmlFor="new-group-exhibitor">Expositor</label>
        </div>
      <button className="send-btn">Enviar</button>
      </form>
    </Modal>
    <AreYouSure isActive={sureModal} handle={handleSureModal} title='¿Borrar grupo?'/>
    </>)
}